import {create} from "zustand";

interface DashboardStore {
    update: boolean;
    setUpdate: (update: boolean) => void;

    openModalInforDirection: boolean;
    setOpenModalInforDirection: (openModalInforDirection: boolean) => void;

    textDirection: string;
    setTextDirection: (textDirection: string) => void;

    resetDashboard: () => void;
}

export const useDashboardStore = create<DashboardStore>((set) => ({
    update: false,
    setUpdate: (update) => set(() => ({ update })),

    openModalInforDirection: false,
    setOpenModalInforDirection: (openModalInforDirection) => set(() => ({ openModalInforDirection })),

    textDirection: "",
    setTextDirection: (textDirection) => set(() => ({ textDirection })),

    resetDashboard: () => set(() => ({update: false, openModalInforDirection: false})),
}));